export default "__VITE_ASSET__f96e9b8d__"